import React from 'react'
import PropTypes from 'prop-types'
import { Card, Descriptions, Typography } from 'antd'
import { formatDateTime, money, refundedSoFar } from './utils'

// The money, and nothing that moves it. The dashboard records refunds; Paystack makes them.
const PaymentPanel = ({ shipment }) => {
  const row = shipment || {}
  const payment = row.payment || {}

  if (!row.paid) {
    return (
      <Card title="Payment">
        <span style={{ opacity: 0.65 }}>Not paid yet</span>
        {payment.status ? <div>{payment.status}</div> : null}
      </Card>
    )
  }

  return (
    <Card title="Payment">
      <Descriptions size="small" bordered column={2}>
        <Descriptions.Item label="Reference">
          {payment.reference ? (
            <Typography.Text copyable>{payment.reference}</Typography.Text>
          ) : (
            '—'
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Status">{payment.status || '—'}</Descriptions.Item>
        {/* The price locked onto this purchase when the customer reached the pay screen — not
            today's price. */}
        <Descriptions.Item label="Amount">
          {money(payment.amount, payment.currency)}
        </Descriptions.Item>
        <Descriptions.Item label="Rail">{payment.rail || '—'}</Descriptions.Item>
        <Descriptions.Item label="Paid at">
          {formatDateTime(payment.paidAt)}
        </Descriptions.Item>
        <Descriptions.Item label="Gateway reference">
          {payment.gatewayReference ? (
            <Typography.Text copyable>{payment.gatewayReference}</Typography.Text>
          ) : (
            '—'
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Refunds recorded" span={2}>
          <div>{money(refundedSoFar(row), payment.currency)}</div>
          <div style={{ opacity: 0.65 }}>
            Recorded here by the team. Refunds are made in Paystack by hand.
          </div>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}

PaymentPanel.propTypes = {
  shipment: PropTypes.object
}

export default PaymentPanel
